import React, { useContext, useEffect, useReducer, useState } from "react";
import { Collapse } from "react-bootstrap";
import { MenuList } from "./Menu";
import { ThemeContext } from "../../../context/ThemeContext";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBar = () => {
  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
    ChangeIconSidebar,
  } = useContext(ThemeContext);

  const date = new Date();
  const [heartBtn, setHeartBtn] = useState();
  const [state, setState] = useReducer(reducer, initialState);

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  };

  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }
  };

  // Scroll hide
  const [hideOnScroll, setHideOnScroll] = useState(true);
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  // Current path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  useEffect(() => {
    MenuList.forEach((data) => {
      data.content?.forEach((item) => {
        if (path === item.to) {
          setState({ active: data.title });
        }
        item.content?.forEach((ele) => {
          if (path === ele.to) {
            setState({
              activeSubmenu: item.title,
              active: data.title,
            });
          }
        });
      });
    });
  }, [path]);

  return (
    <div
      onMouseEnter={() => ChangeIconSidebar(true)}
      onMouseLeave={() => ChangeIconSidebar(false)}
      className={`deznav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <div className="deznav-scroll">
        <ul className="metismenu" id="menu">
          {MenuList.map((data, index) => {
            let menuClass = data.classsChange;

            if (menuClass === "menu-title") {
              return (
                <li className={menuClass} key={index}>
                  {data.title}
                </li>
              );
            } else {
              return (
                <li
                  className={`has-menu ${
                    state.active === data.title ? "mm-active" : ""
                  } ${data.to === path ? "mm-active" : ""}`}
                  key={index}
                >
                  {data.content && data.content.length > 0 ? (
                    <>
                      {/* Parent Menu */}
                      <a
                        href="#"
                        className="has-arrow ai-icon"
                        onClick={() => handleMenuActive(data.title)}
                      >
                        {data.iconStyle}
                        <span className="nav-text">{data.title}</span>
                      </a>

                      <Collapse in={state.active === data.title}>
                        <ul>
                          {data.content.map((item, index) => (
                            <li
                              key={index}
                              className={`${
                                state.activeSubmenu === item.title
                                  ? "mm-active"
                                  : ""
                              } ${item.to === path ? "mm-active" : ""}`}
                            >
                              {item.content &&
                              item.content.length > 0 ? (
                                <>
                                  <a
                                    href={`/${item.to}`}
                                    onClick={() =>
                                      handleSubmenuActive(item.title)
                                    }
                                  >
                                    {item.title}
                                  </a>

                                  <Collapse
                                    in={
                                      state.activeSubmenu === item.title
                                    }
                                  >
                                    <ul>
                                      {item.content.map((sub, i) => (
                                        <li key={i}>
                                          <a
                                            href={`/${sub.to}`}
                                            className={`${
                                              path === sub.to
                                                ? "mm-active"
                                                : ""
                                            }`}
                                          >
                                            {sub.title}
                                          </a>
                                        </li>
                                      ))}
                                    </ul>
                                  </Collapse>
                                </>
                              ) : (
                                <a
                                  href={`/${item.to}`}
                                  className={`${
                                    item.to === path
                                      ? "mm-active"
                                      : ""
                                  }`}
                                >
                                  {item.title}
                                </a>
                              )}
                            </li>
                          ))}
                        </ul>
                      </Collapse>
                    </>
                  ) : (
                    /* Direct Menu */
                    <a
                      href={`/${data.to}`}
                      className={`${
                        data.to === path ? "mm-active" : ""
                      }`}
                    >
                      {data.iconStyle}
                      <span className="nav-text">{data.title}</span>
                    </a>
                  )}
                </li>
              );
            }
          })}
        </ul>
      </div>
    </div>
  );
};

export default SideBar;